import {$handleError  } from '@/utils';
import apiService from '@Task/service/document-type.service';

export const DOCUMENT_TYPE = {
  namespaced: true,
  state: {
    
    entries: [],
    total: 0,
    loading: false,
    updateLoading: false,
    options: {
      itemsPerPage:-1
    },
  },
  getters: {
    GET_ENTRIES(state) {
      return state.entries;
    },
    GET_TOTAL(state) {
      return state.total;
    },
    GET_LOADING(state) {
      return state.loading;
    },
    GET_UPDATE_LOADING(state) {
      return state.updateLoading;
    },

    GET_OPTIONS(state) {
      return state.options;
    },
   
  },
  mutations: {
    SET_ENTRIES(state, value) {
      state.entries = value;
    },
    SET_TOTAL(state, value) {
      state.total = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },

    SET_UPDATE_LOADING(state, value) {
      state.updateLoading = value;
    },

    SET_OPTIONS(state, value) {
      state.options = value;
    },
    SET_DATES_STATUS(state, value) {
      state.datesStatus = value;
    },
  },
  actions: {
    GET({ commit, state }) {
      commit('SET_LOADING', true);
      return apiService
        .get(state.options)
        .then((res) => {
          commit('SET_ENTRIES', res.data);
          commit('SET_TOTAL', res.data.total);
        })
        .catch((err) => {
          $handleError(err);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },

    
  
  },
};
